import styled from 'styled-components';

/**
 * Общий вид страниц статистики админки: карточка, фильтр по датам и плитки
 * с числами. Вынесено из Statistics.jsx, когда появилась вторая такая
 * страница (мобильное приложение «Голос Надежды»), — чтобы две страницы
 * не расходились по виду.
 */

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04);
  margin-bottom: 1.5rem;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const DateInputWrap = styled.div`
  .react-datepicker-wrapper { display: block; }

  .react-datepicker__input-container input {
    padding: 0.625rem 0.875rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
    color: #0f172a;
    font-size: 14px;
    font-family: inherit;
    width: 160px;
    transition: border-color 0.15s, box-shadow 0.15s;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: #4f46e5;
      box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
    }
  }

  .react-datepicker {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    font-family: inherit;
  }

  .react-datepicker__header {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    border-radius: 10px 10px 0 0;
  }

  .react-datepicker__current-month { color: #0f172a; font-weight: 600; }
  .react-datepicker__day-name { color: #64748b; }
  .react-datepicker__day { color: #334155; border-radius: 6px; }
  .react-datepicker__day:hover { background: #e0e7ff; color: #4f46e5; }
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: #4f46e5 !important;
    color: #fff !important;
  }
  .react-datepicker__navigation-icon::before { border-color: #64748b; }
`;

export const FetchBtn = styled.button`
  padding: 0.625rem 1.25rem;
  border: none;
  border-radius: 8px;
  background: #4f46e5;
  color: #fff;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.4rem;

  &:hover { background: #4338ca; transform: translateY(-1px); }
  &:disabled { background: #e2e8f0; color: #94a3b8; cursor: not-allowed; transform: none; }
`;

export const Divider = styled.div`
  height: 1px;
  background: #f1f5f9;
  margin: 1.5rem 0;
`;

export const StatusText = styled.p`
  font-size: 14px;
  color: #94a3b8;
  text-align: center;
  padding: 1.5rem 0;
  margin: 0;
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: #ef4444;
  margin: 0;
  padding: 1rem 0;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
`;

export const MetricCard = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  transition: box-shadow 0.15s;

  &:hover { box-shadow: 0 2px 8px rgba(79,70,229,0.08); border-color: #c7d2fe; }
`;

export const MetricLabel = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const MetricValue = styled.p`
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
  letter-spacing: -0.02em;
`;

export const MetricUnit = styled.span`
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
  margin-left: 4px;
`;

export const SectionTitle = styled.p`
  margin: 0 0 1rem 0;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;
